import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectIsAdmin, selectIsProfileLoaded } from "../../store/slices/authSlice";

/**
 * UI guard for /dashboard/admin/* pages: clinic owner / admin only.
 * Rendered inside ProtectedRoute, so auth + profile are already resolved;
 * the profile-loaded check is a belt-and-braces so admins aren't bounced
 * during a refresh. Data access is still enforced by firestore.rules.
 */
function AdminRoute({ children }) {
  const isAdmin = useSelector(selectIsAdmin);
  const isProfileLoaded = useSelector(selectIsProfileLoaded);

  if (!isProfileLoaded) return null;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

export default AdminRoute;
